import { LogLevel, Logger } from "@azure/msal-browser";
// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

// Config object to be passed to Msal on creation
export const msalConfig = {
    auth: {
        clientId: "3a2d7a30-11a8-4606-a740-99320b791a54",
        authority: "https://login.microsoftonline.com/0cd491c5-d61f-431f-990d-3c518dbd1665",
        redirectUri: "/redirect",
        postLogoutRedirectUri: "/logout",
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: isIE || isEdge || isFirefox,
    },
    system: {
        allowNativeBroker: false, // Disables WAM Broker
        logger: new Logger(
            (logLevel, message, containsPii) => {
                console.log('[MSAL]', message);
            },
            {
                level: LogLevel.Verbose,
                piiLoggingEnabled: false,
            },
        ),
    },
};



/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
   eyedogzAPI_EDUser: {
        endpoint: 'https://eyedogzsloan.covington.io/api/EDUser',
        scopes: {
            read: ['https://CovingtonIO.onmicrosoft.com/8e552dda-6e00-4693-a2bc-f4fc2167a02a/API.Use']
        },
    },
};


// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ["User.Read",
        ...protectedResources.eyedogzAPI_EDUser.scopes.read]
};